import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from "react-router-dom";
import ofertasServices from '../services/ofertasServices';
import resourcesServices from '../services/resourcesServices';
import { InputContext } from '../contexts/InputContext';
import { errorClassification } from '../errorHandler';

const ListaOfertas = () => {
  let { tipo } = useParams();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [ofertas, setOfertas] = useState([]);

  useEffect(() => {
    fetchOfertas(tipo);
  }, [tipo]);

  const fetchOfertas = async (tipoArg, estadoArg) => {
    try {
      const data = await resourcesServices.obtenerResources('ofertas', '', '', '', `tipos=${tipoArg||''}`);

      setOfertas(data.data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const convertToTitleCase = (str) => {
    if(str){
      return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    }
  }

  const eliminarOferta = async (oferta) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${oferta.titulo}?`)){
        await ofertasServices.eliminarOferta(oferta.id);

        const copiaOfertas = [...ofertas];
        setOfertas(copiaOfertas.filter((of) => of.id !== oferta.id))
      }
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const detalleOferta = (detalle) => {
    if(detalle === null || detalle.length === 0) {
      return ""
    } else {
      if(detalle.length > 100) {
        return `${detalle.substring(0,100)} [...]`
      } else {
        return detalle
      }
    }
  }

  return (
    <>
        {
          true && (
          <div>
            <div className='text-start mb-3'>
              <h3>{convertToTitleCase(tipo)}</h3>
            </div>
            {
              ofertas && ofertas.map((oferta, index) => (
                <div className="card text-start mx-4 mb-3" key={index}>
                  <div className="card-body">
                    <h5 className="card-title">{oferta.titulo} <span className='text-secondary'>{convertToTitleCase(oferta.tipos)}</span></h5>
                    <h6 className="card-title border-bottom">{oferta.cargo && `${oferta.cargo.codigo} - ${oferta.cargo.nombre} - ${oferta.cargo.agrupamiento}`}</h6>
                    <p className="card-text">{detalleOferta(oferta.detalle)} </p>
                    <Link className="btn btn-secondary me-1" to={`/oferta/${oferta.id}`}>Ver detalle</Link>
                    { (authInformation.rol === 'Admin') && (
                      <>
                      <Link className="btn btn-primary me-1" to={`/oferta/${oferta.id}/edit`}>Editar</Link>
                      <button className="btn btn-danger me-1" onClick={()=>eliminarOferta(oferta)} >Eliminar</button>
                      <Link className="btn btn-warning me-1" to={`/oferta/${oferta.id}/veedores`}>Asignar Veedores</Link>{' '}
                      </>
                    )}

                  </div>
                  <div className="card-footer text-body-secondary">
                  Estado: <b>{oferta.estado}</b>
                  {' | '}
                  {(oferta.fecha_desde && oferta.fecha_hasta) ? `Postulaciones habilitadas entre el ${oferta.fecha_desde_formato_arg} y el ${oferta.fecha_hasta_formato_arg}` : ``}
                  </div>
                </div>
              ))
            }
          </div>
        )
      }
      </>

  );
};

export default ListaOfertas;